<template>
    <div class="modal is-active" v-show="show" transition="modal">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <slot name="title"></slot>
          <button class="delete" aria-label="close" @click="close"></button>
        </header>
        <section class="modal-card-body">
          <slot name="body"></slot>
        </section>
        <footer class="modal-card-foot">
          <slot name="footer"></slot>
          <button class="button" @click="close">Cancel</button>
        </footer>
      </div>
    </div>
</template>

<script>
  export default {
      props: ['show', 'onClose'],
      methods: {
          close: function () {
              this.onClose();
          }
      },
      ready: function () {
        document.addEventListener("keydown", (e) => {
            if (this.show && e.keyCode == 27) {
                //this.$emit('update:show', false)
                this.onClose()
            }
        });
      }
  }
</script>
